export default __webpack_public_path__ + "static/media/melissa_kang.ea2d4def.jpg";